<aside class="seller-sidebar">
    <div class="sidebar-wrapper">
        <div class="side-header">
            <img src="assets/icons/seller-logo.png" class="app-logo" alt="app-logo" />
        </div>
        <div class="side-list">
            <p-panelMenu
                [multiple]="false"
                transitionOptions="300ms cubic-bezier(0.86, 0, 0.07, 1)"
                [model]="items"
                [style]="{ width: '250px' }"></p-panelMenu>
        </div>
    </div>
    <div class="log-out" (click)="logOut()">
        <div *ngIf="storeName" class="flex justify-content-start mx-4">
            <span class="text-center font-bold">{{ storeName }}</span>
        </div>
        <div *ngIf="name" class="flex justify-content-start mx-4">
            <span class="text-center font-bold">{{ name }}</span>
        </div>
        <div class="log-out-button" pRipple>
            <span class="side-bar-icon pi pi-sign-out"></span>
            <span>تسجيل خروج</span>
        </div>
    </div>
</aside>
